import BadgeText from 'components/BadgeText'
import Table, { TRowProp } from 'components/Table'
import { useAppSelector } from 'redux/hooks'

export type TAiCallsDailySummaryTableProp = {
  loading: boolean
  handleFormChange: (key: string, value: any) => void
  clickedRow: (row: TRowProp) => void
}

export default function AiCallsDailySummaryTable({
  loading,
  handleFormChange,
  clickedRow,
}: TAiCallsDailySummaryTableProp): JSX.Element {
  const { page, total, pageSize, data } = useAppSelector(
    state => state.aiCalls,
  )
  const { sort_by, sort } = useAppSelector(state => state.aiCalls.sortData)

  const handleSort = (type: string, value: string) => {
    handleFormChange('sort', {
      type,
      value,
    })
  }

  const columns = [
    {
      key: 'date',
      name: 'DATE',
      className: 'w-[180px]',
      custom: (value: string) => <div>{value || '-'}</div>,
    },
    {
      key: 'total',
      name: 'TOTAL CALLS',
      className: 'w-[160px]',
      sortable: true,
      sortDirection: sort_by === 'total' ? sort : '',
      onSortDirection: (key: string, item: { label: string; value: string }) =>
        handleSort('total', item.value),
      custom: (value: number) => <BadgeText value={String(value || 0)} color='blue' />,
    },
    {
      key: 'awaiting_support',
      name: 'AWAITING SUPPORT',
      className: 'w-[190px]',
      sortable: true,
      sortDirection: sort_by === 'awaiting_support' ? sort : '',
      onSortDirection: (key: string, item: { label: string; value: string }) =>
        handleSort('awaiting_support', item.value),
      custom: (value: number) => (
        <BadgeText value={String(value || 0)} color='yellow' />
      ),
    },
    {
      key: 'awaiting_restaurant',
      name: 'AWAITING RESTAURANT',
      className: 'w-[220px]',
      sortable: true,
      sortDirection: sort_by === 'awaiting_restaurant' ? sort : '',
      onSortDirection: (key: string, item: { label: string; value: string }) =>
        handleSort('awaiting_restaurant', item.value),
      custom: (value: number) => (
        <BadgeText value={String(value || 0)} color='orange' />
      ),
    },
    {
      key: 'closed',
      name: 'CLOSED',
      className: 'w-[140px]',
      sortable: true,
      sortDirection: sort_by === 'closed' ? sort : '',
      onSortDirection: (key: string, item: { label: string; value: string }) =>
        handleSort('closed', item.value),
      custom: (value: number) => <BadgeText value={String(value || 0)} color='green' />,
    },
  ]

  return (
    <Table
      loading={loading}
      columns={columns}
      data={data}
      paginationShow
      total={total}
      current={page}
      resizePageSize={pageSize}
      className='min-w-full'
      onPageNoChange={value => handleFormChange?.('page', value)}
      clickedRow={clickedRow}
    />
  )
}
